







































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { momentTZ as moment, DateRangeValue } from "@/helpers/moment";
import dataApi from "@/services/history";
import { Getter, Mutation } from "vuex-class";

import AccountCell from "@/components/cells/Account.vue";
import ProductIcon from "@/components/ProductIcon.vue";

import { BaseView, Filters, DataReq, Rule, Condition } from "./views/view";

import { NSLog } from "@/helpers/log";
const log = NSLog("components/Pivot");

import { BaseViews } from "./index";
import { save, load } from "../../helpers/storage";
import { isArray } from "util";

@Component({
  components: {
    Pivot,
    AccountCell,
    ProductIcon,
  },
})
export default class Pivot extends Vue {
  get View() {
    if (!this.ViewName || !this.allViews) {
      return;
    }

    const view = this.allViews.find((v: any) => v.name === this.ViewName);
    if (view) {
      return view.definition;
    }
  }
  private get baseView() {
    if (this.BaseViewName) {
      return BaseViews[this.BaseViewName];
    }
    if (this.View) {
      return BaseViews[this.View.BaseViewName];
    }
  }

  private get headers() {
    let colArray;
    if (this.CustomColumns) {
      colArray = this.CustomColumns;
    } else if (this.View && this.View.columns) {
      colArray = this.View.columns;
    }
    if (colArray) {
      const cols: any = [];
      colArray.map((colOrName: string) => {
        let col;

        if ("string" === typeof colOrName) {
          col = this.baseView.Headers.find(
            (hdr: any) => hdr.name === colOrName
          );
        } else {
          col = colOrName;
        }

        if (col) {
          cols.push(col);
        }
      });

      if (!this.datasources) {
        return cols;
      }
      const selectedSources: any = {};
      for (const src of this.datasources) {
        selectedSources[src] = true;
      }
      return cols.filter((col: any) => {
        if (!col.datasources) {
          return true;
        }
        for (const src of col.datasources) {
          if (src in selectedSources) {
            return true;
          }
        }
      });
    }
    return this.baseView.Headers;
  }

  private get datasources() {
    if (this.DataSources) {
      return this.DataSources;
    }
    if (this.View && this.View.DataSources) {
      return this.View.DataSources;
    }
    return [];
  }

  private get items() {
    if (this.loading) {
      return [];
    }

    const data = this.rawData
      .filter((fv: any) => {
        return this.baseView.Filter(fv);
        // add custom filters!
      })
      .map((v: any, idx: number) => {
        v._key = idx;
        return v;
      });

    if (this.pagination.rowsPerPage < 1) {
      this.totalItems = 9999999;
    } else if (data.length < this.pagination.rowsPerPage) {
      this.totalItems =
        (this.pagination.page - 1) * this.pagination.rowsPerPage + data.length;
    } else {
      this.totalItems =
        this.pagination.page * this.pagination.rowsPerPage +
        this.pagination.rowsPerPage;
    }

    if (!this.ShowPagination) {
      // this.pagination = null
    }

    return data;
  }
  // if view name provided, use as base for columns etc, unless overridden by any custom props
  @Prop() public ViewName: any;
  @Getter("views") public allViews: any;

  // if provided, this view won't use the baseViews data source
  @Prop() public StaticData: any;

  @Prop() public BaseViewName: any;
  @Prop() public DateRange: any;

  @Prop() public CustomColumns?: string[];
  @Prop() public CustomFilters?: any[];
  @Prop() public DataSources?: any[];
  @Prop() public DatasourceFilters?: any;

  @Prop() public ShowPagination?: boolean;

  public rawData: any = [];

  @Mutation("setLastErr") public setLastErr: any;
  private totalItems = 10;

  private loading = false;
  private pagination: any = {
    descending: true,
    page: 0,
    rowsPerPage: load("rows-per-page", 10),
    sortBy: "updated_at",
  };
  @Watch("DateRange", { deep: true }) public watchDateFrom() {
    this.getData();
  }
  @Watch("pagination", { deep: true }) public watchPagination() {
    save("rows-per-page", this.pagination.rowsPerPage);
    this.getData();
  }

  @Watch("DatasourceFilters", { deep: true }) public watchDatasourceFilters() {
    this.getData();
  }

  private itemActions(v: any) {
    return this.baseView.ItemActions(v);
  }
  private async getData() {
    if (this.StaticData) {
      this.rawData = this.StaticData;
      return;
    }
    // let filters: Filters = {
    //   from: dr.from.unix(),
    //   to: dr.to.unix(),

    //   pagination: this.pagination
    // };
    // if (this.DatasourceFilters) {
    //   filters.filters = this.DatasourceFilters;
    // }
    // this.rawData = await this.baseView.Data(filters);
    this.loading = true;
    try {
      const rules: Rule | Condition[] = [];
      this.setLastErr(null);
      for (const fName in this.DatasourceFilters) {
        if (!this.DatasourceFilters.hasOwnProperty(fName)) {
          continue;
        }
        const f = this.DatasourceFilters[fName];

        if (f.q) {
          rules.push(f.q());
        } else if (fName === "date-range") {
          if (f.from && f.to) {
            rules.push({
              operator: "date-range",
              key: "updated_at",
              values: [moment(f.from).unix(), moment(f.to).unix()],
            });
          } else {
            rules.push({
              operator: "date-range",
              key: "updated_at",
              value: f,
            });
          }
        } else if (fName === "reference") {
          if (f.length > 2) {
            rules.push({
              operator: "~",
              key: fName,
              value: `%${f}%`,
            });
          }
        } else {
          rules.push({
            operator: "=",
            key: fName,
            [isArray(f) ? "values" : "value"]: f,
          });
        }
      }

      const dataRequest: DataReq = {
        sources: this.datasources,
        columns: this.baseView.Headers.map((ch: any) =>
          ch.value ? ch.value : ch
        ),
        // columns: ["*"],
        filter: {
          condition: "and",
          rules,
        },
        pagination: this.pagination,
      };
      this.rawData = await this.baseView.Data(dataRequest);
    } catch (err) {
      this.setLastErr(err);
      this.rawData = [];
    }
    this.loading = false;
  }

  private created() {
    this.getData();
  }

  private valueStyle(header: any, item: any) {
    return this.baseView.ValueStyle(header, item[header.value], item);
  }

  private expandItem(item: any, expand: any) {
    if (!item.expanded || item.expanded.name !== expand.name) {
      item.expanded = expand;
      return;
    }
    item.expanded = false;
  }
}
